"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onlyDigits = onlyDigits;
exports.onlyAlnum = onlyAlnum;
function onlyDigits(value) {
    return (value !== null && value !== void 0 ? value : '').replace(/\D/g, '');
}
function onlyAlnum(value) {
    return (value !== null && value !== void 0 ? value : '').toUpperCase().replace(/[^0-9A-Z]/g, '');
}
